import { Fragment, type ReactNode } from 'react';
import { Link } from 'react-router-dom';

const TOKEN = /\*\*(.+?)\*\*|\*(.+?)\*|\[([^\]]+)\]\(([^)]+)\)|`([^`]+)`/g;

/**
 * Inline markup for investor copy: **bold**, *italic*, `code` and [label](href).
 * Content lives in data files as plain strings, so the pages stay readable and the
 * figures can be checked against the plan line by line.
 */
export function Rich({ text }: { text: string }) {
  const out: ReactNode[] = [];
  let last = 0;
  let key = 0;
  for (const m of text.matchAll(TOKEN)) {
    const index = m.index ?? 0;
    if (index > last) out.push(<Fragment key={key++}>{text.slice(last, index)}</Fragment>);
    if (m[1] !== undefined) {
      out.push(
        <strong key={key++} className="font-semibold text-slate-100">
          <Rich text={m[1]} />
        </strong>
      );
    } else if (m[2] !== undefined) {
      out.push(<em key={key++}>{m[2]}</em>);
    } else if (m[3] !== undefined && m[4] !== undefined) {
      const href = m[4];
      const cls = 'text-indigo-300 underline decoration-indigo-500/40 underline-offset-2 hover:text-indigo-200';
      out.push(
        href.startsWith('/') ? (
          <Link key={key++} to={href} className={cls}>
            {m[3]}
          </Link>
        ) : (
          <a key={key++} href={href} target="_blank" rel="noopener noreferrer" className={cls}>
            {m[3]}
          </a>
        )
      );
    } else if (m[5] !== undefined) {
      out.push(
        <code key={key++} className="rounded bg-slate-800 px-1 py-0.5 text-[0.92em] text-slate-200">
          {m[5]}
        </code>
      );
    }
    last = index + m[0].length;
  }
  if (last < text.length) out.push(<Fragment key={key++}>{text.slice(last)}</Fragment>);
  return <>{out}</>;
}
